import { forwardRef } from 'react';

import clsx from 'clsx';

import { RockPaperScissors } from 'modules/Room/features/rock-paper-scissors/rock-paper-scissors';

import { MovesEnum } from 'shared/constants/shared-enums';

interface IHandSelectorProps {
  selected: MovesEnum | null;
  disabled?: boolean;
  dimUnselected?: boolean;
  onSelect: (move: MovesEnum) => void;
  className?: string;
}

export const HandSelector = forwardRef<HTMLDivElement, IHandSelectorProps>(
  ({ selected, disabled = false, onSelect, className }, ref) => {
    return (
      <div
        ref={ref}
        className={clsx(
          'mt-3 flex w-full justify-evenly px-0 sm:px-1',
          className,
          disabled && 'pointer-events-none select-none opacity-60',
        )}
        role="radiogroup"
        aria-label="Choose your move"
        aria-disabled={disabled || undefined}
      >
        <RockPaperScissors move={selected} selectMove={onSelect} />
      </div>
    );
  },
);
